export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11513.4f529398.jpg";